import { useState, useEffect } from 'react';
import axios from 'axios';
import { ArrowRight, ArrowLeft, Check } from '@phosphor-icons/react';

const API = process.env.REACT_APP_BACKEND_URL;

export default function FirstLoginOnboarding({ onComplete }) {
  const [guide, setGuide] = useState(null);
  const [step, setStep] = useState(0);

  useEffect(() => {
    (async () => { try { const { data } = await axios.get(`${API}/api/my-guide`); setGuide(data); } catch {} })();
  }, []);

  const handleFinish = async () => {
    try { await axios.put(`${API}/api/auth/mark-onboarded`); } catch {}
    onComplete();
  };

  if (!guide || !guide.sections?.length) return null;

  const sections = guide.sections;
  const current = sections[step];
  const isLast = step === sections.length - 1;
  const progress = ((step + 1) / sections.length) * 100;

  return (
    <div className="fixed inset-0 z-[9999] bg-black/60 flex items-center justify-center p-4" data-testid="first-login-onboarding">
      <div className="bg-white rounded-3xl max-w-md w-full max-h-[80vh] overflow-hidden flex flex-col shadow-2xl">
        {/* Progress bar */}
        <div className="h-1.5 bg-brand-bg">
          <div className="h-full bg-brand-green rounded-full transition-all duration-300" style={{ width: `${progress}%` }} />
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto p-6">
          <p className="text-[10px] text-brand-muted uppercase tracking-wider mb-2">{step + 1} de {sections.length}</p>
          <h3 className="font-heading font-medium text-lg text-brand-text mb-3">{current.title}</h3>
          <div className="text-sm text-brand-muted leading-relaxed" dangerouslySetInnerHTML={{ __html: current.content || '' }} />
        </div>

        {/* Navigation */}
        <div className="p-4 border-t border-brand-border/30 flex items-center justify-between">
          {step > 0 ? (
            <button onClick={() => setStep(step - 1)} className="flex items-center gap-1 text-sm text-brand-muted hover:text-brand-green" data-testid="onboarding-prev">
              <ArrowLeft size={14} /> Anterior
            </button>
          ) : <div />}

          {isLast ? (
            <button onClick={handleFinish} className="bg-brand-green text-white rounded-full px-6 py-2.5 text-sm font-medium flex items-center gap-2" data-testid="onboarding-finish">
              <Check size={14} /> Começar
            </button>
          ) : (
            <button onClick={() => setStep(step + 1)} className="bg-brand-green text-white rounded-full px-5 py-2.5 text-sm font-medium flex items-center gap-1" data-testid="onboarding-next">
              Próximo <ArrowRight size={14} />
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
